<template>
  <vbt-content-box
    :no-content="noContent"
    :loading-error="loadingError"
    :loading="isLoading"
    title="History"
  >
    <vbt-table
      :headers="headers"
      :items="userHistory"
    >
      <template #processed="{ item: { processed } }">
        {{ formatDisplayDate(processed) }}
      </template>
    </vbt-table>

    <vbt-pagination
      v-model="pageNum"
      :items-count="pagedItemsCount"
      :page-size="5"
    />
  </vbt-content-box>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { useDataLoading, usePagination } from '@mixins/factories';

import { formatDisplayDate } from '@helpers';

import { namespace as UsersNamespace, ActionTypes as UsersActionTypes } from '../store.types';

const dataLoadingOptions = {
  getterName: UsersActionTypes.GET_USER_HISTORY, searchable: false, parameterize: true,
};

const paginationOptions = { contentName: 'userHistory' };

const headers = Object.freeze([
  { text: 'Action', value: 'action' },
  { text: 'Processed By', value: 'processedBy' },
  { text: 'Processed Date', value: 'processed' },
  { text: 'Description', value: 'description' },
]);

export default {
  name: 'UmsUserHistoryList',
  mixins: [
    useDataLoading(dataLoadingOptions),
    usePagination(paginationOptions),
  ],
  data: () => ({ headers }),
  computed: {
    ...mapState(UsersNamespace, ['userHistory']),
  },
  methods: {
    ...mapActions(UsersNamespace, [UsersActionTypes.GET_USER_HISTORY]),
    formatDisplayDate,
  },
};
</script>
